import { z } from 'zod';
import { ComponentSchema, SectionSchema } from '../../models';

const ActionsNames = z.union([
    z.literal('addDashboard'),
    z.literal('addSection'),
    z.literal('addComponent'),
    z.literal('updateDashboardCache'),
    z.literal('toggleDashboardCache'),
    z.literal('updateDashboard'),
    z.literal('updateSection'),
    z.literal('updateComponent'),
    z.literal('deleteDashboard'),
    z.literal('deleteSection'),
    z.literal('deleteComponent'),
    z.literal('updateProps'),
    z.literal('updateControlProps'),
    z.literal('appendDashboardData'),
    z.literal('updateControlByControlId'),
]);

export const UpdateDashboardCacheSchema = z.object({
    id: z.string(),
    data: z.any(),
});

export const updateControlByControlIdSchema = z.object({
    controlId: z.string(),
    control: z.any(),
});

export type updateControlByControlId = z.infer<
    typeof updateControlByControlIdSchema
>;

export type UpdateDashboardCache = z.infer<typeof UpdateDashboardCacheSchema>;
export const ToggleDashboardCacheCacheSchema = z.object({
    id: z.string(),
    path: z.string(),
});

export type ToggleDashboardCacheCache = z.infer<
    typeof ToggleDashboardCacheCacheSchema
>;
export const UpdateComponentShared = z.object({
    dashboardId: z.string(),
    sectionId: z.string(),
    componentId: z.string(),
});
export const UpdatePropsSchema = UpdateComponentShared.merge(
    z.object({
        props: z.any(),
    }),
);

export type UpdateProps = z.infer<typeof UpdatePropsSchema>;
export const UpdateControlPropsSchema = UpdatePropsSchema.merge(
    z.object({
        controlId: z.string(),
    }),
);
export type UpdateControlProps = z.infer<typeof UpdateControlPropsSchema>;

export const UpdateComponentSchema = UpdateComponentShared.merge(
    z.object({ component: ComponentSchema.partial() }),
);

export type UpdateComponent = z.infer<typeof UpdateComponentSchema>;

export const UpdateSectionShared = z.object({
    dashboardId: z.string(),
    sectionId: z.string(),
    dashboardCache: z.any().optional(),
});

export const UpdateSectionSchema = UpdateSectionShared.merge(
    z.object({ section: SectionSchema }),
);

export type UpdateSection = z.infer<typeof UpdateSectionSchema>;

export const OpenSectionSchema = UpdateSectionShared;
export type OpenSection = z.infer<typeof OpenSectionSchema>;
export const CloseSectionSchema = UpdateSectionShared;
export type CloseSection = z.infer<typeof CloseSectionSchema>;

export const AppendDashboardDataSchemaPayloadSchema = z.object({
    dashboardId: z.string(),
    key: z.string(),
    data: z.any(),
});

export type AppendDashboardDataPayload = z.infer<
    typeof AppendDashboardDataSchemaPayloadSchema
>;

export const AppendDashboardCachePayloadSchema = z.object({
    dashboardId: z.string(),
    key: z.string(),
    data: z.any(),
    dataType: z.union([z.literal('array'), z.literal('object')]),
});

export type AppendDashboardCachePayload = z.infer<
    typeof AppendDashboardCachePayloadSchema
>;
export const NavigateToUrlSchema = z.object({
    newTab: z.boolean().optional(),
    url: z.string(),
});

export const NavigateToPathSchema = z.object({
    path: z.array(z.string()),
});

export type NavigateToUrl = z.infer<typeof NavigateToUrlSchema>;
export type NavigateToPath = z.infer<typeof NavigateToPathSchema>;
